import {
  logoAfer,
  logoAG2R,
  logoApicil,
  logoApicilxPatrimea,
  logoBnpCARDIF,
  logoCFCAL,
  logoGenerali,
  logoOradeaVie,
  logoSelencia,
  logoSpirica,
  logoSuravenir,
  logoSwissLife,
  logoLFM,
  logoDirectSecurities,
} from '@/assets/logoAssureurs';

export const assureurs = [
  {
    logo: logoSuravenir,
    label: 'Contrats Suravenir',
    assureur: 'Suravenir',
    link: 'https://espaceclient.suravenir.fr/',
    modaleContrats: [
      'M PEA',
      'M PEA PME',
      'M PERP',
      'Meilleurtaux Vie',
      'MonFinancier Liberté Vie',
      'MonFinancier Liberté Capitalisation',
      'Suravenir PER',
      'Meilleurtaux Capitalisation',
      'Meilleurtaux Capitalisation 2',
      'Meilleurtaux PEA PME capi',
      'Meilleurtaux PEA',
      'Meilleurtaux Placement Vie',
      'Meilleurtaux Placement Vie 2',
      'mes-placements Avenir',
      'mes-placements Avenir Capitalisation',
      'mes-placements PEA',
      'mes-placements PEA-PME',
      'mes-placements PERP',
      'mes-placements Retraite',
      'mes-placements Retraite Capitalisation',
      'Marie Quantier',
      'Ethic Vie',
      'Patrimea PERP',
    ],
  },
  {
    logo: logoSpirica,
    label: 'Contrats Spirica',
    assureur: 'Spirica',
    link: 'https://www.sylvea.fr/securite/login.xhtml',
    modaleContrats: [
      'Meilleurtaux Liberté PER',
      'Meilleurtaux Liberté Vie',
      'mes-placements Liberté',
      'Meilleurtaux Liberté capitalisation',
      'Epargne Evolution',
      'mes-placements liberté capitalisation',
      'Epargne Evolution 2',
      'Arborescence Opportunités Capi',
      'Netlife',
      'Netlife 2',
      'Version Absolue Capi 2',
    ],
  },
  {
    logo: logoGenerali,
    label: 'Contrats Generali',
    assureur: 'Generali',
    link: 'https://generali.placement.meilleurtaux.com/',
    modaleContrats: [
      'E-Xaélidia',
      'Himalia Vie et Capitalisation',
      'MonFinancier Vie',
      'Xaélidia',
      'Meilleurtaux Allocation Capitalisation',
      'Meilleurtaux Allocation Vie',
      'mes-placements Madelin',
      'mes-placements Vie',
      'mes-placements Capi',
    ],
  },
  {
    logo: logoApicil,
    label: 'Contrats Apicil',
    assureur: 'Apicil',
    link: 'https://front.apivie.fr/connexion#/',
    modaleContrats: [
      'Frontière Efficiente',
      'M PER by Apicil',
      'Ma Solution PER',
      'PERP Perspective Génération Plus',
      'meilleurtaux PER',
    ],
  },
  {
    logo: logoSwissLife,
    label: 'Contrats SwissLife',
    assureur: 'SwissLife',
    link: 'https://myswisslife.fr/connection/login#/login',
    modaleContrats: ['PER Swisslife Individuel', 'PERP Eres 163x'],
  },
  {
    logo: logoBnpCARDIF,
    label: 'Contrat BNP Paribas',
    assureur: 'BNP_Paribas_Cardif',
    link: 'https://comptes.cardif.fr/web/espace-client/login',
    modaleContrats: ['PERP Cardif Multi-Plus'],
  },
  {
    logo: logoOradeaVie,
    label: 'Contrats Oradea Vie',
    assureur: 'Oradea',
    link: 'https://www.myoradeavie.fr/',
    modaleContrats: [
      'PERP Lignage',
      'Patrimea Premium GP',
      'Patrimea Premium',
      'PER Lignage',
      'Oradea vie multisupport',
    ],
  },
  {
    logo: logoSelencia,
    label: 'Contrat Selencia Patrimoine',
    assureur: 'Selencia',
    link: 'https://selencia-patrimoine.fr/',
    modaleContrats: ['Gaipare Zen'],
  },
  {
    logo: logoCFCAL,
    label: 'Contrat CFCAL',
    assureur: 'CFCAL',
    link: 'https://epargne.cfcal-banque.fr/',
    modaleContrats: ['Livret meilleurtaux'],
  },
  {
    logo: logoAG2R,
    label: 'Contrat AG2R La Mondiale',
    assureur: 'AG2R',
    link: 'https://private.lamondiale.lu/login',
    modaleContrats: ['Life Mobility Evolution'],
  },
  {
    logo: logoApicilxPatrimea,
    label: 'Contrats Apicil x Patrimea',
    assureur: 'Apicil_Patrimea',
    link: 'https://front-client.intencial.fr/connexion?fromURl=%2Fcontrat#/',
    modaleContrats: [
      'Liberalys Vie',
      'INTENCIAL GESTION PRIVEE 2',
      'P-PER / Intencial liberalys retraite',
      'Perspective Generation Plus',
      'Performance Absolue Vie',
      'APICIL EPARGNE INVESTISSEMENT',
      'INTENCIAL ARCHIPEL PLUS',
      'INTENCIAL ARCHIPEL',
    ],
  },

  {
    logo: logoLFM,
    label: 'Contrats La France Mutualiste',
    assureur: 'La France Mutualiste',
    link: 'https://espaceperso.la-france-mutualiste.fr/',
    modaleContrats: ['Meilleurtaux Essentiel Vie'],
  },
  {
    logo: logoDirectSecurities,
    label: 'Contrats Direct Securities',
    assureur: 'Direct Securities',
    link: 'https://meilleurtaux.directsecurities.fr/fr/login',
    modaleContrats: [
      'Meilleurtaux PEA',
      'Meilleurtaux PEA-PME',
      'Meilleurtaux Compte Titres Ordinaire',
      'Meilleurtaux Compte Titres Ordinaire personne morale',
    ],
  },
  {
    logo: logoAfer,
    label: 'Contrats AFER',
    assureur: 'AFER',
    link: 'https://adherent.gie-afer.fr/espaceadherent/MonCompte/Connexion',
    modaleContrats: [
      "Contrat collectif d'assurance-vie en vue de la retraite en €",
      "Contrat collectif d'assurance-vie multisupport Afer",
      "Contrat collectif d'assurance-vie en vue de la retraite DSK",
      "Contrat collectif d'assurance-vie multisupport - Art.82",
    ],
  },
];
